import { Kinesis, Firehose } from 'aws-sdk';

function processPayload(name, payload) {
  return JSON.stringify({
    event: name,
    now: Date.now(),
    distinct_id: payload.distinct_id || "",
    body: JSON.stringify(payload)
  }) + "\n"
}

function kinesisError(err, data) {
  if (err) console.log("error putting record in kinesis stream", err, err.stack, data)
}

function kinesis() {
  return new Kinesis({
    accessKeyId: process.env.REACT_APP_AWS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET,
    region: process.env.REACT_APP_AWS_KINESIS_REGION
  })
}

function trackKinesis(name, payload) {
  kinesis().putRecord({
    StreamName: process.env.REACT_APP_AWS_KINESIS_STREAM,
    PartitionKey: name,
    Data: processPayload(name, payload)
  }, kinesisError)
}

function firehose() {
  return new Firehose({
    accessKeyId: process.env.REACT_APP_AWS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET,
    region: process.env.REACT_APP_AWS_KINESIS_REGION
  })
}

export default function trackFirehose(name, payload) {
  firehose().putRecord({
    DeliveryStreamName: process.env.REACT_APP_AWS_KINESIS_STREAM,
    Record: {
      Data: processPayload(name, payload)
    }
  }, kinesisError)
}




// WEBPACK FOOTER //
// ./src/store/mixpanel/kinesis.js